import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// CRITICO: instala o interceptor global de WL (axios + fetch) ANTES de
// qualquer pagina ser montada. Evita race-condition em que a primeira
// chamada de /api/usuarios em /wl/<slug>/dashboard/usuarios vazava sem
// tenant_id.
import { installWlGlobalInterceptor } from "./utils/wlGlobalInterceptor";
import { installAppAuthInterceptor } from "./utils/appAuthInterceptor";
installWlGlobalInterceptor();
installAppAuthInterceptor();

const SlhDocumentoPublicoPage = React.lazy(() => import("./pages/SlhDocumentoPublicoPage"));
const SlhAssinaturaPage = React.lazy(() => import("./pages/SlhAssinaturaPage"));
const MonicaPage = React.lazy(() => import("./pages/MonicaPage"));

// Pages
const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const ConselhoEstrategicoPage = React.lazy(() => import("./pages/ConselhoEstrategicoPage"));
const AssociacaoProfissionalPage = React.lazy(() => import("./pages/AssociacaoProfissionalPage"));
const DocumentosLGPDPage = React.lazy(() => import("./pages/DocumentosLGPDPage"));
const MidiaMetrumLandingPage = React.lazy(() => import("./pages/MidiaMetrumLandingPage"));
const MidiaMetrumAccessPage = React.lazy(() => import("./pages/MidiaMetrumAccessPage"));
const PdfCraftPage = React.lazy(() => import("./pages/PdfCraftPage"));
const MidiaMetrumAdminPage = React.lazy(() => import("./pages/dashboard/MidiaMetrumAdminPage"));
const SevenConstrutoraPage = React.lazy(() => import("./pages/SevenConstrutoraPage"));
const SolarianImpactHubPage = React.lazy(() => import("./pages/SolarianImpactHubPage"));
const ForLifeFoundationPage = React.lazy(() => import("./pages/ForLifeFoundationPage"));
const SolarianImpactHubAdminPage = React.lazy(() => import("./pages/dashboard/SolarianImpactHubAdminPage"));
const ConceitoVitalPage = React.lazy(() => import("./pages/ConceitoVitalPage"));
const ConceitoVitalPanelPage = React.lazy(() => import("./pages/ConceitoVitalPanelPage"));
const HubSegurosPage = React.lazy(() => import("./pages/HubSegurosPage"));
const HubSegurosAdminPage = React.lazy(() => import("./pages/dashboard/HubSegurosAdminPage"));
import { publicPortalRoutes } from "./routes/publicPortalRoutes";
const LoginPage = React.lazy(() => import("./pages/LoginPage"));
const RegisterPage = React.lazy(() => import("./pages/RegisterPage"));
const RecuperarSenhaPage = React.lazy(() => import("./pages/RecuperarSenhaPage"));
const DashboardLayout = React.lazy(() => import("./pages/DashboardLayout"));
const PreviewBannerPage = React.lazy(() => import("./pages/PreviewBannerPage"));
const MarktBusinessPage = React.lazy(() => import("./pages/MarktBusinessPage"));
const MarktOfferPublicaPage = React.lazy(() => import("./pages/MarktOfferPublicaPage"));
const MarktOfferDetalhesPage = React.lazy(() => import("./pages/MarktOfferDetalhesPage"));
const MarktOfferConversaPage = React.lazy(() => import("./pages/MarktOfferConversaPage"));
const AssetFlowPublicoPage = React.lazy(() => import("./pages/AssetFlowPublicoPage"));
const AssetFlowCanteiroPage = React.lazy(() => import("./pages/AssetFlowCanteiroPage"));
const ProdutoDetalhesPage = React.lazy(() => import("./pages/ProdutoDetalhesPage"));
const ServicoDetalhesPage = React.lazy(() => import("./pages/ServicoDetalhesPage"));
const SalaReuniaoPage = React.lazy(() => import("./pages/SalaReuniaoPage"));
const BioPage = React.lazy(() => import("./pages/BioPage"));
const BioEmpresaPage = React.lazy(() => import("./pages/BioEmpresaPage"));
const LinkExternoPage = React.lazy(() => import("./pages/LinkExternoPage"));
const DemoReunioesPage = React.lazy(() => import("./pages/DemoReunioesPage"));
const ApresentacaoMetrumPage = React.lazy(() => import("./pages/ApresentacaoMetrumPage"));
const CreditoInternacionalPage = React.lazy(() => import("./pages/CreditoInternacionalPage"));
const ProdutoSofiaPage = React.lazy(() => import("./pages/ProdutoSofiaPage"));
const GuardianPage = React.lazy(() => import("./pages/GuardianPage"));
const GuardianClientePage = React.lazy(() => import("./pages/GuardianClientePage"));
const SofiaNetworkPage = React.lazy(() => import("./pages/SofiaNetworkPage"));
const LaraPage = React.lazy(() => import("./pages/LaraPage"));
const LaraExecutivePage = React.lazy(() => import("./pages/LaraExecutivePage"));
const PrecatorioScorePublicoPage = React.lazy(() => import("./pages/PrecatorioScorePublicoPage"));
const PrecatorioScoreDocumentacaoPage = React.lazy(() => import("./pages/PrecatorioScoreDocumentacaoPage"));
const PrecatorioScorePainelPage = React.lazy(() => import("./pages/PrecatorioScorePainelPage"));
const PrecatorioLaudoAutorizacaoPage = React.lazy(() => import("./pages/PrecatorioLaudoAutorizacaoPage"));
const PrecatorioJuridicoPage = React.lazy(() => import("./pages/PrecatorioJuridicoPage"));
const PrecatorioEmissaoMultiplaPage = React.lazy(() => import("./pages/PrecatorioEmissaoMultiplaPage"));
const PositioningScoreLaudoPage = React.lazy(() => import("./pages/PositioningScoreLaudoPage"));
const BibliotecaPublicaPage = React.lazy(() => import("./pages/BibliotecaPublicaPage"));
const CompensacaoICMSPublicaPage = React.lazy(() => import("./pages/CompensacaoICMSPublicaPage"));
const CheckoutPage = React.lazy(() => import("./pages/CheckoutPage"));
const WhiteLabelPreviewPage = React.lazy(() => import("./pages/WhiteLabelPreviewPage"));
const WhiteLabelLayout = React.lazy(() => import("./pages/WhiteLabelLayout"));
const SoftLabelLandingPage = React.lazy(() => import("./pages/SoftLabelLandingPage"));
const AnalisadorPublicoPage = React.lazy(() => import("./pages/AnalisadorPublicoPage"));
import RouteTracker from "./components/RouteTracker";
import InstitutionalFoundationFooter from "./components/InstitutionalFoundationFooter";
const AdminAnalisadorPage = React.lazy(() => import("./pages/AdminAnalisadorPage"));
const AdminHubWorkConnectPage = React.lazy(() => import("./pages/AdminHubWorkConnectPage"));
const AnaliseDossiePage = React.lazy(() => import("./pages/AnaliseDossiePage"));
const AnaliseClientePage = React.lazy(() => import("./pages/AnaliseDossiePage").then(mod => ({ default: mod.AnaliseClientePage })));
const UsuarioDetalhesPage = React.lazy(() => import("./pages/dashboard/UsuarioDetalhesPage"));
const HubWorkLandingPage = React.lazy(() => import("./pages/HubWorkLandingPage"));
const HubWorkNetworkManualPage = React.lazy(() => import("./pages/HubWorkNetworkManualPage"));
const WhiteLabelLandingPage = React.lazy(() => import("./pages/WhiteLabelLandingPage"));
const LucsamParticipacoesPage = React.lazy(() => import("./pages/LucsamParticipacoesPage"));
const HunterSimuladorPage = React.lazy(() => import("./pages/HunterSimuladorPage"));
const HunterCredTechSimuladorPage = React.lazy(() => import("./pages/HunterCredTechSimuladorPage"));
const HubWorkPortalLayout = React.lazy(() => import("./pages/HubWorkPortalLayout"));
const GuardianPortalLayout = React.lazy(() => import("./pages/GuardianPortalLayout"));
const MarktPlacePage = React.lazy(() => import("./pages/MarktPlacePage"));
const SmartLandHubPage = React.lazy(() => import("./pages/SmartLandHubPage"));
const SmartEquityDownloadPage = React.lazy(() => import("./pages/SmartEquityDownloadPage"));
const LiquidaPage = React.lazy(() => import("./pages/LiquidaPage"));
const LiquidaCasosPage = React.lazy(() => import("./pages/LiquidaCasosPage"));
const LiquidaCalculadorasPage = React.lazy(() => import("./pages/LiquidaCalculadorasPage"));
const CreditoPage = React.lazy(() => import("./pages/CreditoPage"));
const CreditoCasosPage = React.lazy(() => import("./pages/CreditoCasosPage"));
const CreditoMapaAtuacaoPage = React.lazy(() => import("./pages/CreditoMapaAtuacaoPage"));
const RecuperaPage = React.lazy(() => import("./pages/RecuperaPage"));
const RecuperaAcessoPage = React.lazy(() => import("./pages/RecuperaAcessoPage"));
const RecuperaNetworkPage = React.lazy(() => import("./pages/RecuperaNetworkPage"));
const RecuperaAdminPage = React.lazy(() => import("./pages/dashboard/RecuperaAdminPage"));
const CreditoAcessoPage = React.lazy(() => import("./pages/CreditoAcessoPage"));
const ComplianceGuardAdminStandalonePage = React.lazy(() => import("./pages/ComplianceGuardAdminStandalonePage"));
const CredTechAdminPageStandalone = React.lazy(() => import("./pages/dashboard/CredTechAdminPage"));
const MetrumGemsLandingPage = React.lazy(() => import("./pages/MetrumGemsLandingPage"));
const MetrumGemsConformidadePage = React.lazy(() => import("./pages/MetrumGemsConformidadePage"));
const MetrumGemsAccessPage = React.lazy(() => import("./pages/MetrumGemsAccessPage"));
const MetrumGemsPrivateOfferPage = React.lazy(() => import("./pages/MetrumGemsPrivateOfferPage"));
const MetrumGemsSupplierInvitePage = React.lazy(() => import("./pages/MetrumGemsSupplierInvitePage"));
const MetrumGemsValidationPage = React.lazy(() => import("./pages/MetrumGemsValidationPage"));
const MetrumGemsAdminPage = React.lazy(() => import("./pages/dashboard/MetrumGemsAdminPage"));
const CredTechProdutoPublicoPage = React.lazy(() => import("./pages/CredTechProdutoPublicoPage"));
const CredTechEnvioBancoPublicoPage = React.lazy(() => import("./pages/CredTechEnvioBancoPublicoPage"));
const CredTechLaraAdminPage = React.lazy(() => import("./pages/dashboard/CredTechLaraAdminPage"));
const CreditoNetworkPage = React.lazy(() => import("./pages/CreditoNetworkPage"));
const CreditoJuridicoPage = React.lazy(() => import("./pages/CreditoJuridicoPage"));
const CreditoRelatorioPage = React.lazy(() => import("./pages/CreditoRelatorioPage"));
const EduSysClientePage = React.lazy(() => import("./pages/EduSysClientePage"));
const SmartLandHubPublicPage = React.lazy(() => import("./pages/SmartLandHubPublicPage"));
const SmartLandHubMirassolPage = React.lazy(() => import("./pages/SmartLandHubMirassolPage"));
const SmartLandHubAcessoPage = React.lazy(() => import("./pages/SmartLandHubAcessoPage"));
const SmartLandHubClienteAreaPage = React.lazy(() => import("./pages/SmartLandHubClienteAreaPage"));
const SmartLandHubControladorPage = React.lazy(() => import("./pages/dashboard/SmartLandHubControladorPage"));
const PerfilEmpresaPublicoPage = React.lazy(() => import("./pages/PerfilEmpresaPublicoPage"));
const AtivoPublicoPage = React.lazy(() => import("./pages/AtivoPublicoPage"));
const AnaliseCreditoPublicaPage = React.lazy(() => import("./pages/publico/AnaliseCreditoPublicaPage"));
const FormularioPesquisaPublicoPage = React.lazy(() => import("./pages/FormularioPesquisaPublicoPage"));
const AcademiaPublicaPage = React.lazy(() => import("./pages/AcademiaPublicaPage"));
const GarantiasLandingPage = React.lazy(() => import("./pages/GarantiasLandingPage"));
const GarantiasCalculadorasPage = React.lazy(() => import("./pages/GarantiasCalculadorasPage"));
const GarantiasCompliancePage = React.lazy(() => import("./pages/GarantiasCompliancePage"));
const GarantiasCotacaoPage = React.lazy(() => import("./pages/GarantiasCotacaoPage"));

// Public Pages (no auth required)
const PublicModulosPage = React.lazy(() => import("./pages/public/PublicModulosPage"));
const PublicServicosPage = React.lazy(() => import("./pages/public/PublicServicosPage"));
// Auth Components
const AuthCallback = React.lazy(() => import("./components/AuthCallback"));
const ProtectedRoute = React.lazy(() => import("./components/ProtectedRoute"));
const CredTechAdminGate = React.lazy(() => import("./components/CredTechAdminGate"));
const ChatWidget = React.lazy(() => import("./components/ChatWidget"));
const CenariosEconomicosSection = React.lazy(() => import("./components/CenariosEconomicosSection"));
const GlobalSoftLabelProductShowcase = React.lazy(() => import("./components/GlobalSoftLabelProductShowcase"));

// Cart
import { CartProvider } from "./contexts/CartContext";
const CartDrawer = React.lazy(() => import("./components/CartDrawer"));

/**
 * AppRouter Component
 * Handles routing with OAuth callback detection.
 * Detects session_id in URL fragment BEFORE rendering routes.
 * 
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */

// Atalhos públicos curtos para WL franqueados ativos.
// Cada entrada cria uma rota /{slug} que abre a landing page do franqueado.
// IMPORTANTE: o slug DEVE existir em db.franqueados.subdominio.
// Não use slugs que conflitem com rotas existentes (ex: 'login', 'dashboard').
const WL_SHORTCUTS = [
  'parceirosp',
];

const isCreditoLanding = (pathname) => /^\/(credito|credtech)\/?$/.test(pathname);

function GlobalCartDrawer() {
  const location = useLocation();
  if (isCreditoLanding(location.pathname)) return null;
  return <React.Suspense fallback={null}><CartDrawer /></React.Suspense>;
}

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // ChatWidget global é escondido nas rotas da Rede Sofia
  // (a página /sofia já tem seu próprio chat WhatsApp-like — evita poluição visual)
  // Também escondemos nas landing pages White Label (/wl/*/landing)
  // — a landing é uma página institucional que deve ficar limpa.
  const isAnalisePrivada = location.pathname.startsWith("/analise/compartilhada/") || location.pathname.startsWith("/p/admin-hubworkconnect/analises/");
  const hideChatWidget = isAnalisePrivada || location.pathname === '/ferramentas/pdf' || location.pathname.startsWith('/sofia')
    || /^\/monica(?:\/|$)/.test(location.pathname)
    || /^\/wl\/[^/]+\/landing/.test(location.pathname)
    || location.pathname === '/wl/lucsamparticipacoes'
    || isCreditoLanding(location.pathname)
    || location.pathname.startsWith("/recupera");

  // METRUM GEMS opera como mercado privado: não exibe a vitrine pública
  // das demais verticais da Conceito em nenhuma rota deste produto.
  const hideProductShowcase = isAnalisePrivada || location.pathname.startsWith('/metrum-gems') || location.pathname === '/ferramentas/pdf';
  
  return (
    <>
      <RouteTracker />
      <React.Suspense fallback={<div className="grid min-h-[45vh] place-items-center text-sm font-semibold text-slate-500">Carregando módulo…</div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/conselho-estrategico" element={<ConselhoEstrategicoPage />} />
        <Route path="/associacao-profissional" element={<AssociacaoProfissionalPage />} />
        <Route path="/associados/contratos" element={<DocumentosLGPDPage />} />
      <Route path="/midiametrum" element={<MidiaMetrumLandingPage />} />
      <Route path="/midiametrum/acesso" element={<MidiaMetrumAccessPage />} />
      <Route path="/ferramentas/pdf" element={<ProtectedRoute><PdfCraftPage /></ProtectedRoute>} />
      <Route path="/midiametrum/admin" element={<ProtectedRoute><MidiaMetrumAdminPage /></ProtectedRoute>} />
      <Route path="/seven-construtora" element={<SevenConstrutoraPage />} />
      <Route path="/solarian-impact-hub" element={<SolarianImpactHubPage />} />
      <Route path="/forlifefoundation" element={<ForLifeFoundationPage />} />
      <Route path="/solarian-impact-hub/segmento/:slug" element={<SolarianImpactHubPage />} />
      <Route path="/solarian-impact-hub/admin" element={<ProtectedRoute><div className="min-h-screen bg-slate-100 p-4 md:p-7"><SolarianImpactHubAdminPage standalone /></div></ProtectedRoute>} />
      <Route path="/conceito-vital" element={<ConceitoVitalPage />} />
      <Route path="/conceito-vital/painel" element={<ProtectedRoute><ConceitoVitalPanelPage /></ProtectedRoute>} />
      <Route path="/conceito-vital/admin" element={<ProtectedRoute><ConceitoVitalPanelPage admin /></ProtectedRoute>} />
      <Route path="/hub-seguros" element={<HubSegurosPage />} />
      <Route path="/hub-seguros/admin" element={<ProtectedRoute><HubSegurosAdminPage /></ProtectedRoute>} />
      <Route path="/MIDIAMETRUM" element={<Navigate to="/midiametrum" replace />} />
      <Route path="/preview-banner" element={<PreviewBannerPage />} />
      <Route path="/marktbusiness" element={<MarktBusinessPage />} />
      <Route path="/creditointernacional" element={<CreditoInternacionalPage />} />
      <Route path="/produtos/sofia" element={<ProdutoSofiaPage />} />
      <Route path="/hubworkconnect" element={<HubWorkLandingPage />} />
      <Route path="/guardian" element={<GuardianPage />} />
      <Route path="/guardian/:slug" element={<GuardianClientePage />} />
      <Route path="/sofia" element={<SofiaNetworkPage />} />
      <Route path="/lara" element={<ProtectedRoute><LaraPage /></ProtectedRoute>} />
      <Route path="/monica" element={<ProtectedRoute><MonicaPage /></ProtectedRoute>} />
      <Route path="/lara-executive" element={<LaraExecutivePage />} />
      {/* Link curto — /s redireciona para /sofia (fácil de compartilhar) */}
      <Route path="/s" element={<Navigate to="/sofia" replace />} />
      <Route path="/sofia/precatorioscore" element={<SofiaNetworkPage moduloInicial="precatorioscore" />} />
      <Route path="/sofia/cadastro" element={<SofiaNetworkPage moduloInicial="novos_cadastros" />} />
      {/* /precatorioscore = landing marketplace (Entrar/Cadastrar).
          Login redireciona para /p/analisador-creditos, que já tem a Sofia
          como ferramenta interna (widget flutuante). */}
      <Route path="/precatorioscore" element={<PrecatorioScorePublicoPage />} />
      <Route path="/precatorioscore/documentacao" element={<PrecatorioScoreDocumentacaoPage />} />
      <Route path="/precatorioscore/painel" element={<ProtectedRoute><PrecatorioScorePainelPage /></ProtectedRoute>} />
      <Route path="/precatorioscore/laudo-autorizacao/:token" element={<PrecatorioLaudoAutorizacaoPage />} />
      <Route path="/precatorioscore/juridico" element={<PrecatorioJuridicoPage />} />
      <Route path="/precatorioscore/biblioteca" element={<BibliotecaPublicaPage />} />
      <Route path="/precatorioscore/compensacao-icms" element={<CompensacaoICMSPublicaPage />} />
      <Route path="/marketplace" element={<MarktPlacePage />} />
      <Route path="/smartlandhub" element={<SmartLandHubPage />} />
      <Route path="/liquida" element={<LiquidaPage />} />
      <Route path="/liquida/casos" element={<LiquidaCasosPage />} />
      <Route path="/liquida/calculadoras" element={<LiquidaCalculadorasPage />} />
      {/* METRUM GEMS — vitrine institucional, acesso e operação privada */}
      <Route path="/metrum-gems" element={<MetrumGemsLandingPage />} />
      <Route path="/metrum-gems/conformidade" element={<MetrumGemsConformidadePage />} />
      <Route path="/metrum-gems/conformidade/diamantes-brutos" element={<MetrumGemsConformidadePage product="diamantes-brutos" />} />
      <Route path="/metrum-gems/acesso" element={<MetrumGemsAccessPage />} />
      <Route path="/metrum-gems/fornecedor/:token" element={<MetrumGemsSupplierInvitePage />} />
      <Route path="/metrum-gems/validacao/:token" element={<MetrumGemsValidationPage />} />
      <Route path="/metrum-gems/oferta/:token" element={<MetrumGemsPrivateOfferPage />} />
      <Route path="/metrum-gems/admin" element={<ProtectedRoute><MetrumGemsAdminPage /></ProtectedRoute>} />
      <Route path="/credito" element={<CreditoPage />} />
      <Route path="/credito/casos" element={<CreditoCasosPage />} />
      <Route path="/credito/mapa-de-atuacao" element={<CreditoMapaAtuacaoPage />} />
      <Route path="/recupera" element={<RecuperaPage />} />
      <Route path="/recupera/acesso" element={<RecuperaAcessoPage />} />
      <Route path="/recupera/network" element={<RecuperaNetworkPage />} />
      <Route path="/recupera/admin" element={<ProtectedRoute><RecuperaAdminPage /></ProtectedRoute>} />
      <Route path="/credtech" element={<Navigate to={`/credito${location.search}${location.hash}`} replace />} />
      <Route path="/credito/acesso" element={<CreditoAcessoPage />} />
      <Route path="/credito/produto/:produtoId" element={<CredTechProdutoPublicoPage />} />
      <Route
        path="/credtech/produto/:produtoId"
        element={<Navigate to={`/credito${location.pathname.slice('/credtech'.length)}${location.search}${location.hash}`} replace />}
      />
      <Route path="/credito/envio-banco/:token" element={<CredTechEnvioBancoPublicoPage />} />
      <Route path="/credito/admin" element={<ProtectedRoute><CredTechAdminGate><div className="min-h-screen bg-slate-100 p-4 md:p-7"><CredTechAdminPageStandalone /></div></CredTechAdminGate></ProtectedRoute>} />
      <Route path="/credito/admin/lara" element={<ProtectedRoute><CredTechAdminGate><CredTechLaraAdminPage /></CredTechAdminGate></ProtectedRoute>} />
      <Route path="/credito/network" element={<CreditoNetworkPage />} />
      <Route path="/compliance-guard/admin" element={<ProtectedRoute><ComplianceGuardAdminStandalonePage /></ProtectedRoute>} />
      <Route path="/credito/juridico" element={<CreditoJuridicoPage />} />
      <Route path="/credito/relatorio/:token" element={<CreditoRelatorioPage />} />
      <Route path="/edusys/:slug" element={<EduSysClientePage />} />
      <Route path="/smartlandhub/hub" element={<SmartLandHubPublicPage />} />
      {/* Rota case-insensitive: aceita /Mirassol, /mirassol, /MIRASSOL */}
      <Route path="/smartlandhub/Mirassol" element={<SmartLandHubMirassolPage />} />
      <Route path="/smartlandhub/mirassol" element={<SmartLandHubMirassolPage />} />
      <Route path="/smartlandhub/MIRASSOL" element={<SmartLandHubMirassolPage />} />
      <Route path="/smartlandhub/:projeto/acesso" element={<SmartLandHubAcessoPage />} />
      <Route path="/smartlandhub/:projeto/cliente" element={<SmartLandHubClienteAreaPage />} />
      <Route path="/smartlandhub/:projeto/documento/:documentoId" element={<SlhDocumentoPublicoPage />} />
      <Route path="/smartlandhub/:projeto/assinar/:contratoId" element={<SlhAssinaturaPage />} />
      <Route path="/smartlandhub/:projeto/dashboard" element={<SmartLandHubControladorPage />} />
      {/* SEO-friendly slug-based routes (primary) */}
      <Route path="/marktbusiness/produto/:identifier" element={<ProdutoDetalhesPage />} />
      <Route path="/marktbusiness/servico/:identifier" element={<ServicoDetalhesPage />} />
      <Route path="/marktoffer" element={<MarktOfferPublicaPage />} />
      <Route path="/marktoffer/oferta/:id" element={<MarktOfferDetalhesPage />} />
      <Route path="/marktoffer/conversa/:id" element={<MarktOfferConversaPage />} />
      <Route path="/assetflow/publico/:slug" element={<AssetFlowPublicoPage />} />
      <Route path="/assetflow/canteiro/:token" element={<AssetFlowCanteiroPage />} />
      <Route path="/reuniao/:reuniaoId" element={<SalaReuniaoPage />} />
      <Route path="/smart-equity-download/:token" element={<SmartEquityDownloadPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/esqueci-senha" element={<RecuperarSenhaPage />} />
      <Route path="/redefinir-senha" element={<Navigate to="/esqueci-senha" replace />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* Public Pages - No Authentication Required */}
      <Route path="/modulos" element={<PublicModulosPage />} />
      <Route path="/servicos" element={<PublicServicosPage />} />
      {/* SEO-friendly slug route for services */}
      <Route path="/servico/:identifier" element={<LandingPage />} />
      <Route path="/bio/empresa" element={<BioEmpresaPage />} />
      <Route path="/bio/:slug" element={<BioPage />} />
      <Route path="/perfil-empresa/:userId" element={<PerfilEmpresaPublicoPage />} />
      <Route path="/ativo-publico/:ativoId" element={<AtivoPublicoPage />} />
      <Route path="/publico/analisador-creditos/:token" element={<AnaliseCreditoPublicaPage />} />
      <Route path="/formulario-pesquisa/:formularioId" element={<FormularioPesquisaPublicoPage />} />
      <Route path="/academia" element={<AcademiaPublicaPage />} />
      <Route path="/link/:bioSlug/:linkId" element={<LinkExternoPage />} />
      <Route path="/demo/reunioes" element={<DemoReunioesPage />} />
      <Route path="/apresentacao-metrum" element={<ApresentacaoMetrumPage />} />
      <Route path="/checkout/:tipo/:id" element={<CheckoutPage />} />
      
      {/* Protected Dashboard */}
      <Route 
        path="/dashboard/*" 
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        } 
      />

      {/* Portal HubWork — ambiente dedicado para clientes do HubWorkConnect */}
      <Route
        path="/portal-hubwork/*"
        element={
          <ProtectedRoute>
            <HubWorkPortalLayout />
          </ProtectedRoute>
        }
      />

      {/* Portal Guardian — ambiente dedicado para clientes do Guardian (só Smart Equity) */}
      <Route
        path="/portal-guardian/*"
        element={
          <ProtectedRoute>
            <GuardianPortalLayout />
          </ProtectedRoute>
        }
      />
      
      {/* Rotas públicas/portais — ver src/routes/publicPortalRoutes.js */}
      {publicPortalRoutes}

      {/* White Label - Nova estrutura com rotas dedicadas */}
      {/* /wl/{slug}/landing = Landing Page do franqueado */}
      {/* /wl/{slug} = Login do franqueado */}
      {/* /wl/{slug}/dashboard/* = Dashboard e módulos do franqueado */}
      {/* Landing institucional exclusiva da Lucsam Participações */}
      <Route path="/wl/lucsamparticipacoes" element={<LucsamParticipacoesPage />} />
      <Route path="/wl/hubworkconnect/landing" element={<HubWorkNetworkManualPage />} />
      <Route path="/wl/:slug/landing" element={<WhiteLabelLandingPage />} />
      <Route path="/wl/hubworkconnect/hunter/simuladores/credtech" element={<HunterCredTechSimuladorPage />} />
      <Route path="/wl/hubworkconnect/hunter/simuladores/:simuladorId" element={<HunterSimuladorPage />} />
      <Route path="/wl/:slug/*" element={<WhiteLabelLayout />} />

      {/* ===== ATALHOS DE URL CURTA PARA WL FRANQUEADOS =====
          Para adicionar um novo atalho: inclua o slug em `WL_SHORTCUTS`
          (definido acima do componente App). Ex: /hubworkconnect carrega
          direto a landing page do franqueado, sem `/wl/` no caminho.
          Bom para marketing, e-mail e redes sociais (branding limpo). */}
      {WL_SHORTCUTS.map((slug) => (
        <Route
          key={`wl-shortcut-${slug}`}
          path={`/${slug}`}
          element={<WhiteLabelLandingPage slug={slug} />}
        />
      ))}

      {/* Rota pública restrita: portal Analisador (acessado da landing PrecatorioScore) */}
      <Route path="/p/analisador-creditos" element={<AnalisadorPublicoPage />} />
      <Route path="/p/analisador-creditos/emitir" element={<ProtectedRoute><PrecatorioEmissaoMultiplaPage /></ProtectedRoute>} />
      <Route path="/dashboard/smart-equity/positioning-score/laudo/:analiseId" element={<ProtectedRoute><PositioningScoreLaudoPage /></ProtectedRoute>} />

      {/* Área Administrativa do Analisador (layout limpo SEM sidebar do dashboard) */}
      <Route path="/p/admin-analisador" element={<AdminAnalisadorPage />} />

      {/* Área Administrativa do HubWorkConnect (layout limpo SEM sidebar do dashboard) */}
      <Route path="/p/admin-hubworkconnect" element={<AdminHubWorkConnectPage />} />
      <Route path="/p/admin-hubworkconnect/analises/:sid" element={<AnaliseDossiePage />} />
      <Route path="/analise/compartilhada/:token" element={<AnaliseClientePage />} />
      <Route
        path="/p/admin-hubworkconnect/cadastro/:usuarioId"
        element={<ProtectedRoute><UsuarioDetalhesPage /></ProtectedRoute>}
      />

      {/* Garantias / Fiança Real Fidejussória */}
      <Route path="/garantias" element={<GarantiasLandingPage />} />
      <Route path="/garantias/calculadoras" element={<GarantiasCalculadorasPage />} />
      <Route path="/garantias/compliance/:slug" element={<GarantiasCompliancePage />} />
      <Route path="/garantias/cotacao" element={<GarantiasCotacaoPage />} />
      <Route path="/garantias/cotacao/:tokenConvite" element={<GarantiasCotacaoPage />} />

      {/* Placeholder routes for HubWork Connect navigation */}

      {/* Catch-all: Landing pública de produto Soft Label habilitado. */}
      <Route path="/:slug" element={<SoftLabelLandingPage />} />
      </Routes>
      </React.Suspense>
      {!hideProductShowcase && <React.Suspense fallback={null}><GlobalSoftLabelProductShowcase /></React.Suspense>}
      {!hideChatWidget && <React.Suspense fallback={null}><ChatWidget /></React.Suspense>}
      {location.pathname === '/' && <CenariosEconomicosSection />}
      {!isAnalisePrivada && <InstitutionalFoundationFooter pathname={location.pathname} />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <AppRouter />
          <GlobalCartDrawer />
        </BrowserRouter>
      </CartProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;







